import { createSlice } from "@reduxjs/toolkit";
export const costHistorySlice = createSlice({
  name: "costHistory",
  initialState: {
    costHistory: [],
    UploadImage: false,
  },
  reducers: {
    getCostHistory: (state, action) => {
      state.costHistory = action.payload;
    },
    getUploadImageFlag: (state, action) => {
      state.UploadImage = action.payload;
    },
  },
});
export const { getCostHistory, getUploadImageFlag } = costHistorySlice.actions;
export default costHistorySlice.reducer;
